<template>
  <div>
    <input
      :id="id"
      type="checkbox"
      v-model="checked"
      @change="change"
      :disabled="disabled ? true : false"
    />
  </div>
</template>

<script>
export default {
  emits: ['change-value'],
  props: ['id', 'field', 'value', 'disabled'],
  data() {
    return { checked: this.value }
  },
  watch: {
    value(val) {
      this.checked = val
    },
  },
  methods: {
    change(e) {
      this.$emit('change-value', e.target.checked, this.field)
    },
  },
}
</script>

<style lang="scss">
input[type='checkbox'] {
  appearance: none;
  background-color: var(--color-01);
  margin: 0;
  font: inherit;
  color: var(--color-14);
  width: 25px;
  height: 25px;
  border: 1px solid var(--color-14);
  border-radius: 4px;
  transform: translateY(-0.075em);
  display: grid;
  place-content: center;
}

input[type='checkbox']::before {
  content: '';
  color: var(--color-23);
  width: 25px;
  height: 25px;
  border: 4px solid var(--color-23);
  border-radius: 4px;
  transform: scale(0);
  box-shadow: inset 1em 1em var(--form-control-color);
  background-color: var(--color-23);
  background-image: url('../../assets/images/icons/check-icon.svg');
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center;
}

input[type='checkbox']:checked::before {
  transform: scale(1);
}

input[type='checkbox']:disabled {
  cursor: no-drop;
}
</style>
